import { IconCypressColor, IconJavaColor, IconWebdriverioColor } from '@saucelabs/ds-icons';
import { Typography } from '@saucelabs/ds-typography';
import React from 'react';
import { Link } from '@saucelabs/ds-link';
import { NoData } from '@saucelabs/ds-data-states';
import Button from '@saucelabs/ds-button';

import { GetStartedCard } from './GetStartedCard';

const BuildsGuide = () => (
  <div
    className="flex flex-col items-center justify-center flex-grow px-2"
  >
    <NoData
      className="mb-3"
      description="Get clear and instant visibility into the impact of code changes on your user interface across browsers, devices, and operating systems. Get started in minutes with our quick start guides."
      spacing="large"
      title="Run Your First Visual Test"
    />

    <Button
      component="a"
      href="https://docs.saucelabs.com/visual-testing/index.html"
      target="_blank"
    >
      Check Documentation
    </Button>

    <Typography
      className="mt-8 mb-4"
      variant="heading-2"
    >
      Sample projects
    </Typography>
    <div className="w-full max-w-4xl gap-2 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
      <GetStartedCard
        href="https://github.com/saucelabs/visual-examples/tree/main/wdio"
        icon={IconWebdriverioColor}
        tags={['JavaScript']}
        title="WebdriverIO"
      />
      <GetStartedCard
        href="https://github.com/saucelabs/visual-examples/tree/main/cypress"
        icon={IconCypressColor}
        tags={['JavaScript']}
        title="Cypress"
      />
      <GetStartedCard
        href="https://github.com/saucelabs/visual-examples/tree/main/wd-java"
        icon={IconJavaColor}
        tags={['JUnit', 'TestNG']}
        title="Java"
      />
    </div>
    <div className="mt-2">
      <Typography variant="heading-2">
        Helpful resources
      </Typography>
      <ul className="list-none p-0 m-0 text-center">
        <li>
          <Link
            inline
            isExternal
            target="_blank"
            to="https://docs.saucelabs.com/web-apps/"
          >
            Get started with Automated Testing
          </Link>
        </li>
        <li>
          <Link
            inline
            isExternal
            target="_blank"
            to="https://docs.saucelabs.com/visual-testing/index.html"
          >
            Getting started with Visual Testing
          </Link>
        </li>
        <li>
          <Link
            inline
            isExternal
            target="_blank"
            to="https://docs.saucelabs.com/secure-connections/sauce-connect/"
          >
            Set up Sauce Connect Proxy
          </Link>
        </li>
      </ul>
    </div>

  </div>
);

export default BuildsGuide;
